import { render, staticRenderFns } from "./HayaPriceField.vue?vue&type=template&id=3d00534a&scoped=true&"
import script from "./HayaPriceField.vue?vue&type=script&lang=js&"
export * from "./HayaPriceField.vue?vue&type=script&lang=js&"
import style0 from "./HayaPriceField.vue?vue&type=style&index=0&id=3d00534a&prod&lang=sass&"
import style1 from "./HayaPriceField.vue?vue&type=style&index=1&id=3d00534a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d00534a",
  null
  
)

export default component.exports